import { ApiService } from '@/services/api.service'
import { LanternReason, MapBounds } from '@/types'

export const Lanterns = {
  async lanterns (bounds?: MapBounds) {
    const params = {} as {['filter[point.contained]']: string}
    if (bounds) {
      const filterParam = `SRID=4326;POLYGON((${bounds._northEast.lng} ${bounds._northEast.lat},
                                    ${bounds._northEast.lng} ${bounds._southWest.lat},
                                    ${bounds._southWest.lng} ${bounds._southWest.lat},
                                    ${bounds._southWest.lng} ${bounds._northEast.lat},
                                    ${bounds._northEast.lng} ${bounds._northEast.lat}))`
      params['filter[point.contained]'] = filterParam.replace(/\n|\r/g, '')
    }

    const response = await ApiService.get('lanterns/', {
      params
    })
    return response.data.data
  },

  async lantern (pk: string) {
    const response = await ApiService.get(`lanterns/${pk}`)
    return response.data.data
  },

  async accidentReasons () {
    const response = await ApiService.get('accident-reasons/')
    return response.data.data
  },

  async reportLantern (data: LanternReason) {
    await ApiService.post('accidents/', {
      data: {
        type: 'Accident',
        attributes: data
      }
    })
  }
}
